import { connect } from 'react-redux'
import { selectCurrentConversation } from 'ducks/tickets/selectors/selectCurrentConversation'
import View from './view'

const select = state => ({
  ticket: selectCurrentConversation(state),
})

export default connect(select)(View)
